module.exports = __webpack_public_path__ + "img/ir.9bb2c335.svg";